export default "/_next/static/chunks/fonts/WhitneySSm-BookItalic-Pro_Web-8c7f51634008af6e5c021028c52f107d.woff2";